import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { KOSTENTRAEGER } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import { assignIdsToStruc } from 'src/utils/helper';
import { VNTreeStructureAbschluss } from '../default-content/abschluss-seite/VNTreeStructureAbschluss';
import { VNTreeStructureErklaerungen } from '../default-content/erklaerungen/VNTreeStructureErklaerungen';
import { VNTreeStructureProjektDaten } from '../default-content/projekt-daten/VNTreeStructureProjektDaten';
import { VNTreeStructureWichtigeHinweis } from '../default-content/wichtige-hinweise/VNTreeStructureWichtigeHinweis';
import BescheidDaten from './BescheidDaten';
import EigenmittelVNLIS, { getFormStrucEigenmittelVNLIS } from './eigenmittel-lis/EigenmittelVNLIS';
import EmobLisSachbericht from './EmobLisSachbericht';
import VNFinanzierungsPlanLIS from './finanzierung-plan/VNFinanzierungsPlanLIS';
import { GetInvestitionskostenVNLIS } from './investitionkosten-lis/GetInvestitionsKostenVNLIS';
import NachweisBeklebung from './NachweisBeklebung';

export const VNTreeStructureEmobLis = (application: any, kostenKategories: any[], readOnly: boolean, _alleVerwendungsnachweise?: any[]) => {
	let treeNodes: TreeNodeType[] = [
		...VNTreeStructureWichtigeHinweis(application),
		// Projekt Daten
		...VNTreeStructureProjektDaten(application),
		{
			label: 'Übersicht Bewilligung',
			content: <BescheidDaten />,
		},
		// Investitionskosten
		...InvestitionskostenStructure(application, kostenKategories, readOnly),
		// Mittelabruf (Ursprunglich Ausgaben und Finanzierungplan)
		{
			label: 'Mittelabruf',
			content: <VNFinanzierungsPlanLIS />,
		},
		// Verwendungsnachweis (Ursprunglich Eigenmittel)
		{
			label: 'Verwendungsnachweis',
			content: <EigenmittelVNLIS kostentraeger={KOSTENTRAEGER.Antragsteller} unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: getFormStrucEigenmittelVNLIS(application, KOSTENTRAEGER.Antragsteller, get(getLocalstorageToken(), 'organisationId'), readOnly),
		},
		// Sachbericht
		{
			label: 'Sachbericht',
			content: <EmobLisSachbericht />,
		},
		// Nachweis Beklebung mit Checkbox und Bilder
		{
			label: 'Nachweis Beklebung',
			content: <NachweisBeklebung />,
		},
		// Erklärungen
		...VNTreeStructureErklaerungen(application),
		// Abschluss
		...VNTreeStructureAbschluss(application),
	];

	return assignIdsToStruc(treeNodes);
};

const InvestitionskostenStructure = (application: any, kostenKategories: any[], readOnly: boolean) => {
	return GetInvestitionskostenVNLIS(application, kostenKategories, readOnly);
};
